import api from "../api";

const endpoint = "/api/setores";
const obterTodos = async () => {
  return new Promise((resolve, reject) => {
    return api
      .get(endpoint)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const obterPorId = async (id) => {
  return new Promise((resolve, reject) => {
    return api
      .get(`${endpoint}/${id}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const cadastrar = async (setor) => {
  return new Promise((resolve, reject) => {
    return api
      .post(endpoint, setor)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const atualizar = async (id, setor) => {
  return new Promise((resolve, reject) => {
    return api
      .put(`${endpoint}/${id}`, setor)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default {
  obterTodos,
  obterPorId,
  cadastrar,
  atualizar,
};
